import { useState } from 'react'
import PropTypes from 'prop-types'
import { ArrowLeft } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { DIGIT_REGEX } from '../../helpers/constants'

const PackageCountSelection = ({ onSelect, onBack }) => {
  const { t } = useTranslation(['package-room', 'common'])
  const [showCustomInput, setShowCustomInput] = useState(false)
  const [customCount, setCustomCount] = useState('')
  const predefinedCounts = [1, 2, 3, 4, 5, 6, 7, 8]

  const handleCustomCountChange = (e) => {
    const value = e.target.value.replace(DIGIT_REGEX, '')
    setCustomCount(value)
  }

  const handleCustomCountSubmit = () => {
    if (customCount && parseInt(customCount) > 0) {
      onSelect(parseInt(customCount))
    }
  }

  const handleOptionSelect = (count) => {
    onSelect(count)
  }

  if (showCustomInput) {
    return (
      <div className="package-room__content package-room__content--full">
        <button className="package-room__back" onClick={() => setShowCustomInput(false)}>
          <ArrowLeft size={24} />
          {t('common:actions.back')}
        </button>
        <h2 className="package-room__title">
          {t('package-room:packageCountSelection.titleCustom')}
        </h2>
        <div className="package-room__custom-input-container">
          <input
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
            value={customCount}
            onChange={handleCustomCountChange}
            placeholder={t('package-room:packageCountSelection.customPlaceholder')}
            className="package-room__custom-input"
            autoFocus
          />
          <button
            className="package-room__submit-button"
            onClick={handleCustomCountSubmit}
            disabled={!customCount || parseInt(customCount) <= 0}
          >
            {t('package-room:packageCountSelection.submit')}
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="package-room__content package-room__content--full">
      <button className="package-room__back" onClick={onBack}>
        <ArrowLeft size={24} />
        {t('common:actions.back')}
      </button>
      <h2 className="package-room__title">
        {t('package-room:packageCountSelection.titleDefault')}
      </h2>
      <div className="package-room__count-grid">
        {predefinedCounts.map((count) => (
          <button
            key={count}
            className="package-room__count-option"
            onClick={() => handleOptionSelect(count)}
          >
            {count}
          </button>
        ))}
        <button className="package-room__count-option" onClick={() => setShowCustomInput(true)}>
          {t('package-room:packageCountSelection.more')}
        </button>
      </div>
    </div>
  )
}

PackageCountSelection.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
}

export default PackageCountSelection
